import { Cabecera, Cuerpo, Fila, Tabla, Td, Th } from "@/componentes/ui/Tabla"

import type { AreaManual } from "./tipos"

/**
 * Las áreas de la agencia en el manual: código, quién responde, de quién dependen y
 * qué puestos tienen. Transcribe el catálogo de departamentos; no redacta nada.
 */
export function TablaEstructura({ areas }: { areas: AreaManual[] }) {
  return (
    <Tabla>
      <Cabecera>
        <Th>Código</Th>
        <Th>Área</Th>
        <Th>Responsable</Th>
        <Th>Depende de</Th>
        <Th>Cargos</Th>
      </Cabecera>
      <Cuerpo>
        {areas.map((a) => (
          <Fila key={a.nombre}>
            <Td numero>{a.codigo ?? "—"}</Td>
            <Td>
              {a.nombre}
              {a.siglas && ` (${a.siglas})`}
            </Td>
            <Td>
              {a.responsable ?? "—"}
              {a.ocupante && ` — ${a.ocupante}`}
              {a.interino && " (interino)"}
            </Td>
            <Td>{a.depende_de ?? "Dirección"}</Td>
            <Td>{a.cargos.length > 0 ? a.cargos.join(", ") : "—"}</Td>
          </Fila>
        ))}
      </Cuerpo>
    </Tabla>
  )
}
